import React, { Component } from 'react';
import ListColumnBtn from '../common/ListColumnBtn';
import { ReactTabulator } from 'react-tabulator';
import { doActivePage } from '../../actions/menu/index';
import { openModal, closeModal, popupModalConfirm, openModalAlert } from '../../actions/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { DELETE_FLOOR_PLAN_SUCCESS, SAVE_FLOOR_PLAN_DATA_FAIL, SAVE_FLOOR_PLAN_DATA_SUCCESS, doSelectFloorPlanProject, getFloorPlanData, setFloorPlanProjectList } from '../../actions/visual';
import '../../resources/css/visual/ProjectList.scss';
// import DrawingApp from './DrawRect';
// import { checkTableAuth } from '../common/access-auth';


let orgFilter;
let componentProps = null;

// const GroupBtnsMenu = (props) => {
//     return (
//         <div className='group-buttons-menu'>
//             <span className='operation-button-area'>
//                 <span className='btn-area'><span className='icon-btn-info-n' onClick={(event) => { event.stopPropagation(event); viewRow(props); }} /></span>
//                 {/* <span className='btn-area'><span className='icon-btn-edit' onClick={(event) => { event.stopPropagation(event); editRow(props); }} /></span>
//                 <span className='btn-area'><span className='icon-btn-delete-n' onClick={(event) => { event.stopPropagation(event); deleteRow(props); }} /></span> */}
//             </span>
//         </div>
//     );
// };


// const addRow = (props) => {
//     if (componentProps) {
//         const { getFloorPlanData, openModal } = componentProps;
//         openModal("FloorPlan", 'add', null, () => getFloorPlanData(null));
//     }
// }

// const editRow = (props) => {
//     let data = props.cell._cell.row.data;
  
//     if (componentProps) {
//       const { getFloorPlanData, openModal } = componentProps;
//       openModal("FloorPlan", 'upd', null, () => getFloorPlanData(data));
//     }
//   }
  
//   const deleteRow = (props) => {
//     let data = props.cell._cell.row.data;
//     if (componentProps) {
//       const { authToken, popupModalConfirm, accountRole, roleTableAuth, openModalAlert } = componentProps;
//       if (checkTableAuth('rf_map', accountRole, roleTableAuth)) {
//         popupModalConfirm('Delete', 'icon-ico-failed', 'Are you sure you want to delete "' + data.name + '" ?', 300, () => {
          
//         }, null, false);
//       } else {
//         openModalAlert("Sorry you don't have permission to change config.");
//       }
//     }
//   }
  

// const viewRow = (props) => {
//     let data = props.cell._cell.row.data;

//     if (componentProps) {
//         const { getFloorPlanData, openModal } = componentProps;
//         openModal("FloorPlan", 'view', null, () => getFloorPlanData(data));
//     }
// }

class ProjectList extends Component {
    tableId = 'ProjectList'
    // set this state for re-fresh sub component
    state = {
        refTable: null,
        isInitComplete: false,
        pageSize: 5,

        visibleColumnsConfig: {
            columns: [
                { title: "ID", field: "seq" },
                { title: "Project Name", field: "name" },
                { title: "Project Type", field: "environment" },
                // { name: 'buttonGroup', title: "buttonGroup", field: "buttonGroup", visible: false }

            ]
        },
    }

    /**
     *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
     *  
     ***/
    columns = [
        { title: "ID", field: "seq", visible: false },
        { title: "Project Name", field: "name" },
        { title: "Project Type", field: "environment" },
        // { title: "", field: "buttonGroup", width: 150, headerSort: false, formatter: reactFormatter(<GroupBtnsMenu />) }


    ];

    dataLoading = (datas) => {
        if (this.ref && !this.state.isInitComplete) {
            if (!componentProps) {
                componentProps = this.props;
            }
            // save into state
            this.setState({
                isInitComplete: true,
                refTable: this.ref.table
            });
        }
    }

    addRow = () => {
        const { openModal, getFloorPlanData } = this.props;
        openModal("FloorPlan", 'add', null, () => getFloorPlanData(null));
    }

    reloadList = (e) => {
        const { refTable } = this.state;
        if (refTable) {
            refTable.clearData();
            refTable.replaceData();
        }
    }

    componentDidMount() {
        const { selectSite } = this.props;
        orgFilter = selectSite;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { menuMode/*, tabulatorDivHeight*/, status, openModalAlert, errMsg, closeModal } = this.props;
        const { refTable } = this.state;

        if (refTable) {
            if (prevProps.menuMode !== menuMode) {
                // if menu chagne size(mode), need redraw table  
                refTable.redraw(true);
            }


            if (prevProps.status !== status) {
                if (DELETE_FLOOR_PLAN_SUCCESS === status || SAVE_FLOOR_PLAN_DATA_SUCCESS === status) {
                    closeModal(null);
                    this.reloadList();
                } else if (status === SAVE_FLOOR_PLAN_DATA_FAIL) {
                    openModalAlert(errMsg);
                }
            }

            // if (prevProps.selectSite !== selectSite) {
            //     orgFilter = selectSite;
            //     this.reloadList();
            // }
        }
    }


    renderTable = () => {
        const { tabulatorDivHeight, authToken, openModal, getFloorPlanData, doSelectFloorPlanProject, setFloorPlanProjectList } = this.props;
        const options = {
            height: tabulatorDivHeight,
            ajaxURL: window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER["visual"] + "/floorplanprojectlist",
            pagination: "local",
            paginationSize: 10, //optional parameter to request a certain number of rows per page
            paginationSizeSelector: true,
            renderComplete: function () {

                    const paginationElement = document.querySelector('.tabulator-paginator');

                    if (paginationElement) {
                        paginationElement.setAttribute('id', 'project-list-pagination');

                        const pageSizeSelect = paginationElement.querySelector('select');
                        if (pageSizeSelect) {
                            pageSizeSelect.setAttribute('id', 'project-list-selections');
                        }
                    }

                    const buttons = paginationElement.querySelectorAll('button');
                    buttons.forEach(button => {
                        switch (button.textContent.trim()) {
                            case 'First':
                                button.setAttribute('id', 'project-list-pagination-first-btn');
                                break;
                            case 'Prev':
                                button.setAttribute('id', 'project-list-pagination-prev-btn');
                                break;
                            case 'Next':
                                button.setAttribute('id', 'project-list-pagination-next-btn');
                                break;
                            case 'Last':
                                button.setAttribute('id', 'project-list-pagination-last-btn');
                                break;
                            default:
                                break;
                        }
                    })

            },

            ajaxConfig: {
                method: 'POST',
                mode: 'cors'
            },
            ajaxContentType: {
                headers: {
                    'Authorization': authToken,
                    'Content-Type': 'application/json',
                },
                body: function (url, config, params) {
                    return orgFilter;
                },
            },

            ajaxResponse: (url, params, response) => {
                doSelectFloorPlanProject(response.data[0]?.seq ?? null, response.data[0]?.environment ?? null, response.data[0]?.address ?? null);
                setFloorPlanProjectList(response.data);
                return response.data; //return the response data to tabulator
            },
            ajaxError: (error) => {
                console.info(this.tableId + ' ajaxError');
            }
        };
        return (
            <ReactTabulator
                ref={(ref) => (this.ref = ref)}
                columns={this.columns}
                data={[]}
                placeholder="No data found"
                options={options}
                className="custom-list-table"  //custom-list-table
                dataLoading={this.dataLoading}
                rowClick={function (e, row) {
                    openModal("FloorPlan", 'view', null, () => getFloorPlanData(row._row.data));
                }}
            />
        );
    }

    render() {
        const { visibleColumnsConfig } = this.state;
        return (
            <>
                <div className='floor-plan-project-list'>
                    {/* <div className='area-list-title'>
                    <div className='area-header'>Radio Clusters</div>
                </div> */}
                    <div className='area-header-btns'>
                        <div id="add-new-project-btn" className='area-add-btn' onClick={this.addRow}>
                            <div className='area-icon'><span className='icon-btn-add-n'></span></div>
                            <div className='area-text'>Add new project</div>
                        </div>
                        <div className='area-column-btn'>
                            <ListColumnBtn tableId={this.tableId}
                                refTable={this.state.refTable}
                                refs={(ref) => { this.refTableToolBar = ref; }}
                                visibleColumnsConfig={visibleColumnsConfig}>
                            </ListColumnBtn>
                        </div>
                    </div>
                    <div className='area-custom-list'>
                        {this.renderTable()}
                    </div>
                    {/* <DrawingApp/> */}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        accountInfo: state.loginReducers.accountInfo,
        menuMode: state.menuReducers.displayMode,
        selectSite: state.siteReducers.selectSite,
        status: state.visualReducers.status,
        errMsg: state.visualReducers.errMsg,
        accountOperationStatusList: state.settingsReducers.accountOperationStatusList,

    }
}

const mapDispatchToProps = {
    doActivePage,
    openModal,
    closeModal,
    popupModalConfirm,
    openModalAlert,
    getFloorPlanData,
    doSelectFloorPlanProject,
    setFloorPlanProjectList

}

export default withRouter(connect(mapStateToProps,
    mapDispatchToProps
)(ProjectList));